import { render, staticRenderFns } from "./unloadingItems.vue?vue&type=template&id=28e32338"
import script from "./unloadingItems.vue?vue&type=script&lang=js"
export * from "./unloadingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports